import React, { useState, useEffect, useRef } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaSearch } from 'react-icons/fa';
import api from '../../services/api';
import moment from 'moment';
import '../../css/financeiro-parcela-pagar.css';

export default function PainelEventoHistorico({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const [eventos, setEventos] = useState([]);
    const [dadosEvento, setDadosEvento] = useState(null);
    const [buscando, setBuscando] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const controllerRef = useRef(null);

    const buscar = () => {
        if (controllerRef.current) controllerRef.current.abort();
        controllerRef.current = new AbortController();
        // Busca dados do evento
        api({
            method: "get",
            action: '/evento/' + id,
            token: token,
            signal: controllerRef.current.signal
        })
            .then(response => {
                setDadosEvento(response.data.data);
            }).catch(err => {
                if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
                //console.log(err)
            });

        // Busca histórico do evento
        setBuscando(true);
        api({
            method: "get",
            action: '/eventoHistorico/evento/' + id,
            token: token,
            signal: controllerRef.current.signal
        })
            .then(response => {
                setEventos(response.data.data);
                setBuscando(false);
            }).catch(err => {
                if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
                setBuscando(false);
                //console.log(err)
            });
    };

    useEffect(() => { //onload
        buscar();
        return () => { if (controllerRef.current) controllerRef.current.abort(); };
    },
        // eslint-disable-next-line
        []);

    const total = eventos.length;
    const totalPaginas = Math.max(1, Math.ceil(total / pageSize));
    const paginados = eventos.slice((page - 1) * pageSize, page * pageSize);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Histórico — {dadosEvento?.nome ?? 'Carregando...'}</h1>
                        {dadosEvento?.cliente?.nome && (
                            <p className="fin-pp__subtitle">Cliente: {dadosEvento.cliente.nome}</p>
                        )}
                    </div>
                </div>

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: 200 }}>Data</th>
                                    <th style={{ width: 150 }}>Usuário</th>
                                    <th>Histórico</th>
                                </tr>
                            </thead>
                            <tbody>
                                {buscando ? (
                                    <tr><td colSpan={3} className="fin-pp__empty"><span className="fin-pp__loading"><span className="fin-pp__spin"></span>Buscando...</span></td></tr>
                                ) : paginados.length === 0 ? (
                                    <tr><td colSpan={3} className="fin-pp__empty">Nenhum registro</td></tr>
                                ) : paginados.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.data ? moment(row.data).format("DD/MM/YYYY H:m:s") : ""}</td>
                                        <td>{row.usuario ? row.usuario.nome : ""}</td>
                                        <td>{row.historico ?? ""}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="fin-pp__pagination">
                        <div className="fin-pp__pagination-info">{total} registros</div>
                        <div className="fin-pp__pagination-ctrls">
                            <select className="fin-pp__select" style={{ height: 34 }} value={pageSize} onChange={e => { setPageSize(Number(e.target.value)); setPage(1); }}>
                                <option value={15}>15 / pág</option>
                                <option value={30}>30 / pág</option>
                                <option value={50}>50 / pág</option>
                            </select>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Anterior</button>
                            <span className="fin-pp__pagination-info">{page} / {totalPaginas}</span>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page >= totalPaginas} onClick={() => setPage(p => p + 1)}>Próxima</button>
                        </div>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
